import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "conrols-wraper" }
const _hoisted_2 = { class: "aligned-controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SegmentActions = _resolveComponent("SegmentActions")!
  const _component_SegmentStateControls = _resolveComponent("SegmentStateControls")!
  const _component_StateTag = _resolveComponent("StateTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SegmentActions, {
        modelValue: _ctx.segmentItem,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.segmentItem) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_SegmentStateControls, {
        modelValue: _ctx.segmentItem,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.segmentItem) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_StateTag, {
      modelValue: _ctx.translationSegment,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.translationSegment) = $event))
    }, null, 8, ["modelValue"])
  ]))
}